import React from "react";
import "./cashrent/css_override.scss";
import { IntercomChat } from "../components/IntercomChat";
import CashrentLayout from "themes/cashrent";

class FrontendLayout extends React.Component {
  render() {
    return (
      <CashrentLayout {...this.props}>
        {this.props.children}
        <IntercomChat/>
      </CashrentLayout>
    );
  }
}


export default FrontendLayout;
